import axiosClient from "./axiosClient";
import { convertParamsToQueryString } from "../utils/convert-params-to-query-string";

const getContactList = (limit, page, params = {}) => {
  let url = `/contact/v2`;
  const {
    q,
    filterByAssociatedStaffId,
    filterByUserStatus,
    filterByIsAssetConnected,
    filterByBankConnectionStatus,
  } = params;

  const filters = {
    limit,
    page,
    q,
    filterByAssociatedStaffId,
    filterByUserStatus,
    filterByBankConnectionStatus,
    filterByIsAssetConnected,
  };

  const queryString = convertParamsToQueryString(filters);
  if (queryString) {
    url += `?${queryString}`;
  }
  return axiosClient.get(url);
};

const getLeadContactList = (limit, page, params = {}) => {
  let url = `/contact/v2/leads`;
  const {
    q,
    filterByAssociatedStaffId,
    filterByUserStatus,
    filterByIsAssetConnected,
    filterByBankConnectionStatus,
  } = params;

  const filters = {
    limit,
    page,
    q,
    filterByAssociatedStaffId,
    filterByUserStatus,
    filterByBankConnectionStatus,
    filterByIsAssetConnected,
  };

  const queryString = convertParamsToQueryString(filters);
  if (queryString) {
    url += `?${queryString}`;
  }
  return axiosClient.get(url);
};

const deleteContactFilter = (id) => {
  const url = `/user-filter/${id}`;
  return axiosClient.delete(url);
};

const manualImportContactList = (payload) => {
  const url = "/contact/manual-import-contact";
  return axiosClient.post(url, payload);
};

const getImportListByJobId = (jobId) => {
  const url = `/contact/import/${jobId}`;
  return axiosClient.get(url);
};

const stopImportJob = (jobId) => {
  const url = `/contact/import/${jobId}/stop`;
  return axiosClient.post(url);
};

const getActiveImport = () => {
  const url = `/contact/import/active`;
  return axiosClient.get(url);
};

const startImportContactsFile = (fileBlob, { staffId } = {}) => {
  const url = "/contact/import/start-file";
  const form = new FormData();
  form.append("file", fileBlob, "contacts.csv");
  if (staffId) {
    form.append("staffId", staffId);
  }
  return axiosClient.post(url, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Create a new alert
const createAlert = (alertData) => {
  const url = "/alert";
  return axiosClient.post(url, alertData);
};

// Get the list of alerts
const getAlertList = () => {
  const url = "/alert";
  return axiosClient.get(url);
};

const getAlertStatistics = (alertId) => {
  const url = `/alert/${alertId}/statistics`;
  return axiosClient.get(url);
};

// Update an existing alert
const updateAlert = ({ id, alertData }) => {
  const url = `/alert/${id}`;
  return axiosClient.put(url, alertData);
};

// Delete an alert
const deleteAlert = (alertId) => {
  const url = `/alert/${alertId}`;
  return axiosClient.delete(url);
};

const companyHideAlert = ({ alertId }) => {
  const url = `/alert/block/company`;
  return axiosClient.post(url, { alertId });
};

const staffHideAlert = ({ alertId }) => {
  const url = `/alert/block/staff`;
  return axiosClient.post(url, { alertId });
};

const getContactListByAlertId = (
  id,
  limit,
  page,
  q,
  filterByAssociatedStaffId,
  filterByUserStatus,
  filterByBankConnectionStatus
) => {
  let url = `/contact/alert/${id}`;
  const filters = {
    limit,
    page,
    q,
    filterByAssociatedStaffId,
    filterByUserStatus,
    filterByBankConnectionStatus,
  };
  const queryString = convertParamsToQueryString(filters);
  if (queryString) {
    url += `?${queryString}`;
  }
  return axiosClient.get(url);
};

const getSatisfiedContactsByAlertIdWithinGivenContacts = (id, contactIds = []) => {
  const contactIdsArrayQuery = contactIds.reduce((acc, contactId) => {
    return `${acc}&cid[]=${contactId}`;
  }, "");
  // On backend side, if limit go above 100, it will return 100 contacts max which is equal to largest rows per page of backoffice pagination
  const url = `/contact/alert/${id}?limit=1000&disableCountTotal=true${contactIdsArrayQuery}`;
  return axiosClient.get(url);
};

const getAlertMatchingHistories = (fromDate, toDate, period) => {
  const url = `/contact/alert/matching-history?fromDate=${fromDate}&toDate=${toDate}&period=${period}`;
  return axiosClient.get(url);
};

const createAlertIgnorance = ({ userId, alertId, startTime, endTime }) => {
  const url = `/alert/ignorance`;
  return axiosClient.post(url, { userId, alertId, startTime, endTime });
};

const deleteAlertIgnorance = (ignoranceId) => {
  const url = `/alert/ignorance/${ignoranceId}`;
  return axiosClient.delete(url);
};

const getIgnoredAlertsByUser = (userId) => {
  const url = `/alert/ignorance?userId=${userId}`;
  return axiosClient.get(url);
};

export {
  getContactList,
  getLeadContactList,
  deleteContactFilter,
  manualImportContactList,
  getImportListByJobId,
  stopImportJob,
  getActiveImport,
  startImportContactsFile,
  createAlert,
  getAlertList,
  updateAlert,
  deleteAlert,
  companyHideAlert,
  staffHideAlert,
  getContactListByAlertId,
  getSatisfiedContactsByAlertIdWithinGivenContacts,
  getAlertMatchingHistories,
  createAlertIgnorance,
  deleteAlertIgnorance,
  getIgnoredAlertsByUser,
  getAlertStatistics,
};
